import axios from "axios";
import { apiClient } from "../api";
import { Model_Login } from "./types/auth";
import { Token } from "../../contexts/UserContext/types";

export const login = (data: Model_Login) => {
  const ac = apiClient()
  const promise = ac.post('/token/', data)
    .then(res => {
      return res.data
    })
  return promise
}

// Exchange a one-time code from Django admin for tokens of the impersonated user.
// Uses plain axios since there are no tokens (and possibly no user context) yet.
export const exchangeImpersonationCode = (code: string): Promise<Token> => {
  return axios.post(`${import.meta.env.VITE_API_URL}/api/token/impersonate/`, { code })
    .then(res => res.data)
}
